import { createBrowserRouter } from "react-router-dom";
import Designer from "../pages/Designer";
import GenerateDxf from "../pages/GenerateDxf";
import HeadlessDxfReport from "../pages/headless/HeadlessDxfReport";
import HeadlessFacetReport from "../pages/headless/HeadlessFacetReport";

const router = createBrowserRouter([
  { path: "/:token/:designID", element: <Designer/>},
  { path: "dxf/:token/:designID", element: <GenerateDxf/>},

  // Headless, GET-navigable report routes for use from another application.
  // Pass project token + UUID in the path (optional ?returnUrl=... for redirect).
  // Both are data-only (reconstructed from model_data) and do NOT boot the 3D
  // Designer. Shade is intentionally not exposed here: it requires the live
  // rendered scene + irradiance compute, which only exist inside the Designer.
  { path: "generate-dxf/:token/:designID", element: <HeadlessDxfReport/>},
  { path: "generate-facet/:token/:designID", element: <HeadlessFacetReport/>},
]);


export default router;
